module.exports = __webpack_public_path__ + "593a3d53/img/search-filter-icon.c4751a52.svg";